<template>
  <CenteredPageContainer :class="$style.page">
    <DashboardPageTodoListSection
      v-if="!!viewer && shouldShowTodoList"
      :class="$style.page__section"
      :viewer="viewer"
    />
    <DashboardPageLineMessageSendingQuotaSection
      v-if="
        !!viewer && viewer.hasLineActivationProvider && lineMessageQuotaResult
      "
      :class="$style.page__section"
      :lineMessageSendingQuota="lineMessageQuotaResult"
    />
    <DashboardPageNewsSection
      v-if="dashboardPageResult"
      :class="$style.page__section"
      :query="dashboardPageResult"
    />
  </CenteredPageContainer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CenteredPageContainer from '@/components/molecules/CenteredPageContainer.vue'
import DashboardPageNewsSection from './DashboardPageNewsSection.vue'
import DashboardPageTodoListSection from './DashboardPageTodoListSection.vue'
import DashboardPageLineMessageSendingQuotaSection from '@/pages/DashboardPage/DashboardPageLineMessageSendingQuotaSection.vue'
import { useHead } from '@unhead/vue'

import {
  useDashboardPageQuery,
  useDashboardPageLineMessageSendingQuotaQuery,
} from './DashboardPage.generated'

useHead({
  title: 'ダッシュボード',
})

// dashboard pageがやることリスト以外も取得しなくてはいけなくなったらここはno-cacheのままで良いのか考える
const { result: dashboardPageResult } = useDashboardPageQuery({
  fetchPolicy: 'no-cache',
})

const viewer = computed(() => dashboardPageResult.value?.viewer)

// LINE 連携済みのプランナーのみ実行する
const { result: lineMessageQuotaResult } =
  useDashboardPageLineMessageSendingQuotaQuery({
    fetchPolicy: 'no-cache',
    enabled: computed(() => viewer.value?.hasLineActivationProvider === true),
  })

const shouldShowTodoList = computed(() => {
  if (!viewer.value) {
    return false
  }

  if (!viewer.value.todoList) {
    return false
  }

  // LINE 連携に対応するプランナーは、自己紹介など設定してもやり取りするユーザーからは見えない
  // よってやることリストを達成しても効果がない
  // なので、やることリストは表示しない
  // そもそも やることリストは SME向けのオンボーディング施策なので、エンプラがメインのいま 必要が見直される機能
  // なので表示・非表示の切り替えは手軽に dolphin で行っている
  if (viewer.value.hasLineActivationProvider) {
    return false
  }

  // __typenameが入るのでbooleanだけにする
  return Object.values(viewer.value.todoList)
    .filter((value): value is boolean => typeof value === 'boolean')
    .some(value => value)
})
</script>

<style lang="scss" module>
.page {
  &__section {
    &:nth-child(n + 2) {
      margin-top: 32px;
    }
  }
}
</style>
